import dayjs from "dayjs";
import { Typography } from "antd";
import { getAlertKind } from "helpers/options/alert_kinds";
import EllipsisText from "components/EllipsisText";

const columns = [
  {
    title: "Rodzaj",
    dataIndex: "kind",
    searchable: false,
    render: (_, { kind, is_important }) => (
      <Typography.Text type={is_important ? "danger" : "success"}>
        {getAlertKind(kind)}
      </Typography.Text>
    ),
  },
  {
    title: "Adres IP",
    dataIndex: "ip_address",
    sortable: false,
    searchable: false,
    search_method: "matches",
    render: (_, { ip_address }) => (
      <EllipsisText text={ip_address} limit={20} />
    ),
  },
  {
    title: "Data",
    dataIndex: "created_at",
    sortable: true,
    searchable: false,
    search_method: "date",
    search_component: "date-picker",
    render: (_, { created_at }) => dayjs(created_at).format("DD-MM-YYYY HH:mm"),
  },
];

export default columns;
